import { ReduxStore } from 'store/types';

function changePasswordIsLoading(state: ReduxStore): boolean {
  return state.auth.changePassword.config.isLoading;
}

export default changePasswordIsLoading;
